export const NOTE_WIDTH = 250; //付箋の固定幅
export const NOTE_HEIGHT = 180; //付箋の固定高
export const PADDING = 50; // 画面端からの最小余白

// AddButton のサイズと位置の定数
// AddButton.css の .button クラスの width と height に合わせる
export const ADD_BUTTON_WIDTH = 250;
export const ADD_BUTTON_HEIGHT = 50; // .button の padding や font-size からおおよその高さを推測
